import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../service/http";

// //Create order
// export const createOnlineOrder = createAsyncThunk("order/createOnlineOrder", async (data, extra) => {
//   const res = await http.post(`/online_store/customer/order/`, data, {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//     },
//   });
//   if (res.data.status === "success") {
//     return res.data.data;
//   }
// });

export const fetchOnlineOrders = createAsyncThunk("onlineOrder/fetchOnlineOrders", async (data, extra) => {
  const res = await http.get(`/online_store/business/customer/orders${data}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

export const fetchMoreOnlineOrders = createAsyncThunk("onlineOrder/fetchMoreOnlineOrders", async (data, extra) => {
  const res = await http.get(data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

//Get order details by ID
export const getOrderDetailsByID = createAsyncThunk("order/getOrderDetailsByID", async (data, extra) => {
  const res = await http.get(`/online_store/business/customer/order/${data}/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data.data;
  }
});

//Change online order status
export const changeOnlineOrderStatus = createAsyncThunk("order/changeOnlineOrderStatus", async (data, extra) => {
  const res = await http.put(`online_store/business/customer/status/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data.data;
  }
});

export const onlineOrderSlice = createSlice({
  name: "onlineOrder",
  initialState: {
    orders: { data: [], next: null },
    orderDetails: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(createOnlineOrder.fulfilled, (state, action) => {
    //   return {
    //     ...state.orders,
    //     orders: {
    //       ...state.orders,
    //       data: [action.payload.data, ...state.orders.data],
    //     },
    //   };
    // });
    builder.addCase(fetchOnlineOrders.fulfilled, (state, action) => {
      return {
        ...state,
        orders: {
          ...state.orders,
          data: action.payload.data,
          next: action.payload.next,
        },
      };
    });
    builder.addCase(fetchMoreOnlineOrders.fulfilled, (state, action) => {
      return {
        ...state,
        orders: {
          ...state.orders,
          data: [...state.orders.data, ...action.payload.data],
          next: action.payload.next,
        },
      };
    });
    builder.addCase(getOrderDetailsByID.fulfilled, (state, action) => {
      return {
        ...state,
        orderDetails: action.payload,
      };
    });
    builder.addCase(changeOnlineOrderStatus.fulfilled, (state, action) => {
      const updatedOrders = state.orders.data.map((order) => {
        if (order.id === action.payload.id) {
          return action.payload;
        }
        return order;
      });

      return {
        ...state,
        orders: {
          ...state.orders,
          data: updatedOrders,
        },
      };
    });
  },
});

export default onlineOrderSlice.reducer;
